"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var noop = function noop() {};

function IconButton(props) {
  var className = props.className,
      children = props.children,
      accent = props.accent,
      disabled = props.disabled,
      onClick = props.onClick,
      selected = props.selected,
      as = props.as,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "children", "accent", "disabled", "onClick", "selected", "as"]);
  var AsComponent = as;
  return _react.default.createElement(AsComponent, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('iconbutton', _styles.iconButton, {
      accent: accent,
      selected: selected
    }, className),
    disabled: disabled,
    onClick: disabled ? noop : onClick
  }), children);
}

IconButton.propTypes = {
  className: _propTypes.default.string,
  accent: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  selected: _propTypes.default.bool,
  as: _propTypes.default.string
};
IconButton.defaultProps = {
  className: '',
  accent: false,
  disabled: false,
  onClick: noop,
  selected: false,
  as: 'button'
};
var _default = IconButton;
exports.default = _default;